import React, { useState } from 'react';

import { useDisclosure } from '@mantine/hooks';
import dayjs from 'dayjs';
import { AthleteRetrieve } from 'types';

import CommunicationsFilters from './components/CommunicationsFilters';
import CommunicationsTableContainer from './components/CommunicationsTableContainer';
import DrawerCommunication from './components/DrawerNotification';
import { SearchFilters } from './types';

interface IAttendanceProps {
  athlete: AthleteRetrieve;
}
const Communications = ({ athlete }: IAttendanceProps): JSX.Element => {
  const today = new Date();
  const initialSearchFiltersValue: SearchFilters = {
    date: [null, today],
    notificationType: '',
    athleteId: athlete.athleteId,
  };

  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [orderingValue, setOrderingValue] = useState('-createdAt');
  const [communicationsId, setCommunicationsId] = useState<string | null>(null);
  const [isViewDrawerOpened, { open: openViewDrawer, close: closeOpenDrawer }] = useDisclosure(false);

  const handleViewCommunication = (id: string): void => {
    setCommunicationsId(id);
    openViewDrawer();
  };

  return (
    <>
      <CommunicationsFilters
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        orderingValue={orderingValue}
        timeType='past'
        defaultEndDate={dayjs(today).endOf('day').toISOString()}
      />

      <CommunicationsTableContainer
        searchFilters={searchFilters}
        timeType='past'
        defaultEndDate={dayjs(today).endOf('day').toISOString()}
        setOrderingValue={setOrderingValue}
        openViewDrawer={handleViewCommunication}
      />

      <DrawerCommunication
        opened={isViewDrawerOpened}
        closeHandler={closeOpenDrawer}
        communicationsId={communicationsId}
        setCommunicationsId={setCommunicationsId}
      />
    </>
  );
};

export default Communications;
